<!--
 * @FileDescription: 操作日志（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-04-15（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="page-container">
      <div class="page-container-height">
          <div class="log-search">
              <a-range-picker  :value="createValue" @change="onChangeData" />
              <a-input placeholder="请输入姓名或手机号查询" class="log-input" v-model="title" allow-clear  @pressEnter="onSearchForm"></a-input>
              <a-button class="button-search" @click.stop="onSearchForm()">查询</a-button>
              <a-button class="button-search1" @click.stop="onRest(1)">重置</a-button>
          </div>
          <a-table :columns="columns"
                   :dataSource="dataSource"
                   :pagination="pagination"
                   :scroll="{y: 'calc(100vh - 400px)' }"
                   bordered
                   @change="handleTableChange"
                   class="table-log-height"
                   rowKey="key">
          </a-table>

      </div>
  </div>
</template>
<script>
import {mixins} from "@/mixins/mixins";
export default {
    mixins:[mixins],
    data() {
        return {
            dataStart:'',
            dataEnd:'',
            title:'',
            columns: [
                {
                    title: '真实姓名',
                    key: 'realName',
                    align: 'center',
                    dataIndex: 'realName',
                },
                {
                    title: '用户账号',
                    key: 'operaterName',
                    align: 'center',
                    dataIndex: 'operaterName',
                },
                {
                    title: '操作模板',
                    dataIndex: 'module',
                    align: 'center',
                    key: 'module',
                },
                {
                    title: '操作内容',
                    key: 'logContent',
                    dataIndex: 'logContent',
                },
                {
                    title: '操作时间',
                    key: 'createTime',
                    align: 'center',
                    dataIndex:'createTime'
                },
            ],
            dataSource: [],
            createValue:null,
        }
    },
    components:{


    },
    watch:{
        pageList: {
            handler(newValue, oldValue) {
                if(!this.isEmpty(newValue.result)){
                    this.dataSource = newValue.result.records
                    this.pagination.current = newValue.result.current
                    this.pagination.total =newValue.result.total
                    this.pagination.pageSize = newValue.result.size
                    this.pages = this.pageList.result.pages
                    this.$store.state.isLoding = false
                }
            },
            deep: true
        },
    },
    mounted(){
        this.getLogList()
    },
    created(){

    },
    methods: {
        /**
         * @description: 日志列表（方法描述）
         */
        getLogList(){
            this.$store.state.isLoding = true
            this.getPageList('/log/api/findLog',
                    {   companyStoreId:this.$store.state.shopId,
                        logType:'2',
                        pageNo:this.pagination.current,
                        pageSize:this.pagination.pageSize,
                        endTime:this.dataEnd,
                        startTime:this.dataStart,
                        keyword:this.title,
                    },{
                        'Content-Type':'application/json'
                    })
        },
        /**
        * @description: 时间选择（方法描述）
        */
        onChangeData(date, dateString) {
            this.createValue = date
            this.dataStart = dateString[0]
            this.dataEnd = dateString[1]
        },
        /**
         * @description: 查询（方法描述）
         */
        onSearchForm(){
            this.pagination.current = 1
            this.getLogList()
        },
        /**
         * @description: 分页（方法描述）
         */
        handleTableChange(pagination, filters, sorter){
            this.pagination.current = pagination.current
            this.pagination.pageSize = pagination.pageSize
            this.getLogList()
        },

        onRest(){
            this.createValue = null
            this.dataStart = ''
            this.dataEnd = ''
            this.title = ''
            this.pagination.current = 1
            this.getLogList()
        },

    },

}
</script>
<style lang="scss">
    .log-search{
        .ant-calendar-picker{
            width: 250px !important;
        }
    }
    .table-log-height{
        .ant-table{
            height: calc(100vh - 320px);
        }
        .ant-table-body{
            max-height: calc(100vh - 400px)!important;
        }
    }
</style>
<style lang="scss" scoped>
    .page-container-height{
        background: #FFFFFF;
        .log-search{
            display: flex;
            align-items: center;
            padding: 20px 0 20px 30px;
            .log-input{
               width: 200px;
               height: 36px;
               line-height: 36px;
                margin: 0 10px;
            }
        }
    }
</style>
